import React, { useContext, useRef, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import TmsCommonService from "../../../services/tms-common.service";
import { BaseContext } from "../../../contexts/BaseContext";
import Webcam from "react-webcam";
import { PagaPassServices } from "../../../services/paga-pass.service";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";

const PagaPassAssign = ({ router }) => {
  const { userDetails } = useContext(BaseContext);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [name, setName] = useState("");

  const [referredName, setReferredName] = useState("");
  const [designation, setDesignation] = useState("");
  const [entryAccess, setEntryAccess] = useState();

  const [mobile, setMobile] = useState();
  const [aadhar, setAadhar] = useState();
  const [capturedImage, setCapturedImage] = useState(null);
  const [array, setArray] = useState([]);
  const [externalPrint, setExternalPrint] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const webcamRef = useRef(null);

  const printTicket = (data) => {
    setArray([
      ["Devotee Name", data?.devoteeName, { margin: "0" }],
      ["Referer Name", data?.referredName, { margin: "0" }],
      ["Referrer Designation", data?.referredDesignation, { margin: "0" }],
      ["Entry Access", data?.entryAccess, { margin: "0" }],
      ["Mobile", data?.mobileNo, { margin: "0" }],
      ["Aadhar", data?.aadharNo, { margin: "0" }],
      ["footer", data?.transactionId, {}, {}, {}, null, data?.createdAt],
    ]);
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const recaptureImage = () => {
    setCapturedImage(null);
  };

  const handleSubmit = async () => {
    if (!capturedImage) {
      notification.info({
        message: "Please capture a photo",
      });
      return;
    }

    // Convert the base64 image data to a binary Blob
    const binaryData = atob(capturedImage.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    let formData = new FormData();
    formData.append("file", blob);

    const url = await TmsCommonService.uploadTempFile(
      formData,
      "person",
      userDetails.user.id
    );

    if (
      name == "" ||
      mobile == "" ||
      referredName == "" ||
      aadhar == "" ||
      entryAccess == ""
    ) {
      notification.info({
        message: "Please fill all the fields",
      });
      setButtonLoading(false);
      return;
    }

    try {
      const data = await PagaPassServices.createPagaPass({
        devoteeName: name,
        referredName,
        photoUrl: url.path,
        mobileNo: String(mobile),
        referredDesignation: designation,
        aadharNo: String(aadhar),
        entryAccess,
      });
      notification.success({
        message: "Successfully created",
      });
      printTicket(data);

      setButtonLoading(false);
      setAadhar("");
      setMobile("");
      setName("");
      setReferredName("");
      setCapturedImage(null);
      setDesignation("");
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title>Assign Special Seva Tickets </Typography.Title>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <div
            style={{
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Devotee Name</label>
              <Input
                size="large"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Referrer Name</label>
              <Input
                size="large"
                value={referredName}
                onChange={(e) => setReferredName(e.target.value)}
                placeholder="Enter Referrer Name"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Referrer Designation</label>
              <Input
                size="large"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Enter Referrer Designation"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Mobile</label>
              <InputNumber
                size="large"
                type="number"
                style={{ width: "100%" }}
                value={mobile}
                onChange={(value) => {
                  if (value.length > 10) {
                    return;
                  }
                  setMobile(value);
                }}
                placeholder="Enter Mobile Number"
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Aadhar No</label>
              <InputNumber
                size="large"
                value={aadhar}
                onChange={(e) => setAadhar(e)}
                style={{ width: "100%" }}
                placeholder="Enter Aadhar Number"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Entry Access</label>
              <Select
                value={entryAccess}
                onChange={(value) => setEntryAccess(value)}
                style={{ width: "100%" }}
              >
                <Select.Option value="A1">A1</Select.Option>
                <Select.Option value="A2">A2</Select.Option>
                <Select.Option value="A3">A3</Select.Option>
              </Select>
            </div>
            <br />
            <Button
              size="large"
              type="primary"
              onClick={(e) => {
                e.preventDefault();
                !buttonLoading && handleSubmit();
              }}
              loading={buttonLoading}
            >
              Submit
            </Button>
          </div>
        </Col>
        <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "400px",
                height: "330px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {capturedImage ? (
                <img
                  src={capturedImage}
                  alt="Captured"
                  width={400}
                  height={330}
                />
              ) : (
                <Webcam
                  className="poscapture"
                  width={400}
                  height={330}
                  ref={webcamRef}
                />
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "30px",
              justifyContent: "center",
            }}
          >
            {!capturedImage ? (
              <Button type="primary" onClick={captureImage}>
                Capture
              </Button>
            ) : (
              <>
                <Button type="primary" onClick={recaptureImage}>
                  Recapture
                </Button>
                <Button type="default" onClick={() => setCapturedImage(null)}>
                  Cancel
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
      <Modal
        visible={isModalVisible}
        width={450}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
      >
        <TmsPrintTicket
          data={array}
          setData={setArray}
          type="Paga Pass"
          from="Counter"
          externalPrint={externalPrint}
          setExternalPrint={setExternalPrint}
          setButtonLoading={setButtonLoading}
          setPrintTicketModal={setIsModalVisible}
          ticketType={""}
        />
      </Modal>
    </>
  );
};

export default withRouter(PagaPassAssign);
